import { AnalyticsService } from '../../../../services/analytics'
import { IWindow } from '../../../../services/analytics/adapters/mparticle'
import { LoginService } from '../../../../services/identity/adapters/loginradius/services/login-service'
import { Utils } from '../../../../utils/common'
import { logger } from '../../../../utils/common/logger'
import { DOMEvents } from '../../../../utils/dom'
import { PageEvents } from './page-events'

declare let window: IWindow
const OK_STATUS = 202

interface IMPIdentity {
    body: any
    getPreviousUser: () => any
    getUser: () => any
    httpCode: number
}

interface IMPAlias {
    httpCode: number
}
export class UserEvents extends PageEvents {

    public userProfile: any

    constructor() {
        super()
    }

    /**
     * Implement mParticle's setUserAttribute - https://docs.mparticle.com/developers/sdk/web/users/#set-user-attributes
     * User reserved attributes: $Age $FirstName $LastName $Gender $Mobile $Address $City $State $Zip $Country
     * @param: string, string
     * @returns: boolean
     */

    public setUserAttribute(attName: string, attValue: string): boolean {
        try {
            if ('' === attValue) {
                this.logCustomError(
                    'Empty attribute value is not acceptable',
                    'Set user attribute - ' + attName
                )
                return false
            }
            const args = arguments
            window.mParticle.ready(() => {
                if (window.mParticle.Identity.getCurrentUser()) {
                    window.mParticle.Identity
                    .getCurrentUser().setUserAttribute
                    .apply(window.mParticle.Identity.getCurrentUser(), args)
                }
            })
            return true
        } catch (e) {
            return false
        }
    }

    /**
     * Implement mParticle's user login - https://docs.mparticle.com/developers/sdk/web/idsync/#login-and-logout
     * with alias call in case of login - https://docs.mparticle.com/developers/sdk/web/idsync/#user-aliasing
     *
     * @param {object}
     * @returns {boolean}
     */

    public userLogin(identityRequest: object, newRegistration = false): boolean {
        try {
            if (Utils.isEmptyObject(identityRequest)) {
                this.logCustomError(
                    'Empty user identity object is not acceptable',
                    'User login'
                )
                return false
            }

            window.mParticle.ready(() => {
                const identityCallback = (result: IMPIdentity) => {
                    // Alias call to append previous events from the session to the new profile
                    if (!newRegistration && result.getPreviousUser() && result.getUser() &&
                        result.getPreviousUser().getMPID() !== result.getUser().getMPID()) {
                        const aliasCallback = (data: IMPAlias) => {
                            if(data.httpCode !== OK_STATUS) {
                                logger('error', `Unable to send alias request `, data)
                            } else {
                                document.dispatchEvent(new CustomEvent(DOMEvents.CUSTOM_EVENT, {
                                    detail: {
                                        anonymous_mpid: result.getPreviousUser().getMPID(),
                                        control_fields: {
                                            mparticle: {
                                                keys: {
                                                    anonymous_mpid: 'anonymous_mpid',
                                                    original_mpid: 'original_mpid'
                                                },
                                                mp_event_type: 'UserContent'
                                            }
                                        },
                                        event_name: AnalyticsService.customEventNames.userAlias,
                                        original_mpid: result.getUser().getMPID()
                                    }
                                }))
                            }
                        }
                        const aliasRequest = window.mParticle.Identity.createAliasRequest(
                        result.getPreviousUser(), result.getUser())
                        window.mParticle.Identity.aliasUsers(aliasRequest, aliasCallback)
                    }
                    if (newRegistration) {
                        LoginService.sendRegistrationAnalytics('traditionalRegister')
                    }
                }
                window.mParticle.Identity.login(identityRequest, identityCallback)
            })
            return true
        } catch(e) {
            logger('error', `Unable to perform login call on mParticle `, e)
            return false
        }
    }
}
